import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AccountService } from './account.service';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../authentication/auth.service';
import { catchError, finalize, switchMapTo, tap } from 'rxjs/operators';
import { RouterMenu } from '@core/config/routing-menu';
import { StorageService, STORAGE_KEY } from '../storage/storage.service';
import { ResponseAccountData } from '@api/models/response-account-data';
import { ErrorHandlerService } from '../errors/error-handler.service';
import { ApiError } from '@api/models';

@Injectable({ providedIn: 'root' })
export class AccountResolve  {
  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private errorHandler: ErrorHandlerService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ResponseAccountData> {
    return this.accountService.getAccount().pipe(
      tap((res) => {
        if (!localStorage.getItem('notificationShown') || localStorage.getItem('notificationShown') === 'true') {
          localStorage.setItem('notificationShown', 'false');
        }
        localStorage.setItem('notification', `${res.OtrosDatosPersona.indPbcHighRisk}`);
        localStorage.setItem('indPubliPe', `${res.OtrosDatosPersona.indPubliPe}`);
        localStorage.setItem('indNoCesiEmpGrupo', `${res.OtrosDatosPersona.indNoCesiEmpGrupo}`);
        localStorage.setItem('email', `${res.DatosPersonales.mail}`)
      }),
      catchError((error) => this.handleError(error))
    );
  }

  private handleError(error: ApiError) {
    return this.authService.logout().pipe(
      switchMapTo(throwError(error)),
      finalize(() => {
        this.errorHandler.showError(error, () => {
          this.router.navigate([RouterMenu.LOGIN]);
          this.storageService.removeItem(STORAGE_KEY.TOKEN);
          this.storageService.removeItem(STORAGE_KEY.TRUSTED_DEVICE_REGISTERED);
          localStorage.clear();
        });
      })
    );
  }
}
